import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { CoverPictureQuery } from '../CoverPictureQuery.graphql.ts';
import type {
	CoverPictureQuery as CoverPictureQueryType,
	CoverPictureQueryVariables as CoverPictureQueryVariablesType,
} from '../__types__/CoverPictureQuery.ts';

export function preloadEditorPageCoverPicture(
	contentId: CoverPictureQueryVariablesType['contentId'],
	draftShareId: CoverPictureQueryVariablesType['draftShareId'],
	useCache: boolean,
) {
	return query<CoverPictureQueryType, CoverPictureQueryVariablesType>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: CoverPictureQuery,
		variables: {
			contentId,
			status: ['current', 'draft'],
			draftShareId,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
